import { FC } from 'react'

import { Box, type DesignSystemTextProps, Grid } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { useProcessAnalytics } from 'modules/processes/hooks/process/useProcessAnalytics'
import { useProcessOverviewTitle } from 'modules/processes/pages/Process/ProcessOverviewPage/useProcessOverviewTitle'
import { useProcessContext } from 'modules/processes/pages/Process/ProcessRootPage'

import { AnalyticsCard } from './AnalyticsCard'

export const ProcessAnalytics: FC = () => {
  const { title, category } = useProcessOverviewTitle()
  const { process } = useProcessContext()

  const { loading, dueTasksCount, incompletedTasksCount, pendingProcessesCount } =
    useProcessAnalytics({
      processId: process.id,
      status: 'incompleted',
      mandatory: true,
      category: category,
    })

  const pendintTitle = title

  const pendingProcess = {
    title: pendintTitle,
    description: i18n.t('processes.materialize_process.analytics.pending_processes.description', {
      type: pendintTitle,
    }),
    value: pendingProcessesCount ?? 0,
  }

  const pendingTasksText = {
    title: i18n.t('processes.materialize_process.analytics.pending_tasks.title'),
    description: i18n.t('processes.materialize_process.analytics.pending_tasks.description'),
    value: incompletedTasksCount ?? 0,
  }

  const overdueTasksText = {
    title: i18n.t('processes.materialize_process.analytics.overdue_tasks.title'),
    description: i18n.t('processes.materialize_process.analytics.overdue_tasks.description'),
    value: dueTasksCount ?? 0,
    color: dueTasksCount ? 'radicalRed1200' : undefined,
  }

  const analyticsData: {
    title: string
    description: string
    value: number
    color?: DesignSystemTextProps['color']
  }[] = [pendingProcess, pendingTasksText, overdueTasksText]

  return (
    <Box paddingY="s32">
      <Grid component="nav" variant="medium">
        {analyticsData.map((item, index) => (
          <AnalyticsCard
            loading={loading}
            key={index}
            title={item.title}
            description={item.description}
            count={item.value}
            {...(item?.color && { color: item?.color })}
          />
        ))}
      </Grid>
    </Box>
  )
}
